// use of "any" in this file has been deemed perfectly ok as it is either necessary or just a pain to do otherwise and typing is not useful outside of this module.
export function debounceAsync<F extends (...args: any[]) => void>(
    func: F,
    wait: number,
    immediate?: boolean
): F {
    let timeout: any;
    let deferred: any;
    let pendingArgs: any[] = [];

    return (function (this: any, ...args: any[]) {
        if (deferred) {
            clearTimeout(timeout);
        } else {
            deferred = defer();
        }

        pendingArgs = args;
        timeout = window.setTimeout(flush.bind(this), wait);

        return deferred.promise;
    } as any) as F;

    function flush(this: any) {
        const thisDeferred = deferred;
        clearTimeout(timeout);

        Promise.resolve(func.apply(this, pendingArgs)).then(
            thisDeferred.resolve,
            thisDeferred.reject
        );

        deferred = null;
    }

    function defer() {
        const deferral: any = {};
        deferral.promise = new Promise((resolve, reject) => {
            deferral.resolve = resolve;
            deferral.reject = reject;
        });
        return deferral;
    }
}

export function debounce<F extends (...args: any[]) => void>(
    func: F,
    wait: number,
    immediate?: boolean
): F {
    let timeout: any;

    return (function (this: any, ...args: any[]) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const context = this;

        const later = () => {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };

        const callNow = immediate && !timeout;

        clearTimeout(timeout);

        timeout = window.setTimeout(later, wait);

        if (callNow) func.apply(context, args);
    } as any) as F;
}
